/** biome-ignore-all lint/suspicious/noArrayIndexKey: allow array index as key */
import {useAutoAnimate} from '@formkit/auto-animate/react';
import {memo} from 'react';
import Skeleton from 'react-loading-skeleton';
import {AmazonBanner} from '~/ViewInvitation/components/Guestlist/AmazonBanner';
import {useGuestlistDataContext} from '~/ViewInvitation/components/Guestlist/hooks/useGuestlistDataContext';
import {Row} from '~/ViewInvitation/components/Guestlist/List/Row';
import {type Guest} from '~/ViewInvitation/types/guests';
import {Typography} from '~library/atoms/Typography';
import {SearchLineIcon} from '~library/svg/SearchLineIcon';

import * as styles from './List.module.scss';

const loadingSkeletons = (
  <div className={styles.loadingSkeletons}>
    {new Array(5).fill(0).map((_, i) => (
      <Skeleton key={`skeleton${i}`} width="100%" height={60} />
    ))}
  </div>
);

export const List = memo(() => {
  const [animation] = useAutoAnimate();
  const {
    state: {guestlist, isLoading, query, rsvpResponse},
  } = useGuestlistDataContext();

  const notEmptyAndLessThan10 = guestlist.length > 0 && guestlist.length < 9;
  const notOnAllFilter = rsvpResponse !== undefined;

  return (
    <div className={styles.list} ref={animation} data-qa-id="whos-coming-guestlist">
      {isLoading && loadingSkeletons}
      {!isLoading && (
        <>
          {guestlist.map((guest: Guest, idx: number) => (
            <Row key={guest?.userId || `${guest?.name}-${idx}`} guest={guest} guestIndex={idx} />
          ))}
          {notEmptyAndLessThan10 && notOnAllFilter && <AmazonBanner />}
          {guestlist.length === 0 && (
            <>
              {!query && (
                <Typography variant="paragraph1" className={styles.empty}>
                  No guests here
                </Typography>
              )}
              {query && (
                <div className={styles.noSearchResults}>
                  <SearchLineIcon ratio={0.75} />
                  <Typography variant="paragraph1">Hmm... we couldn't find anyone</Typography>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
});

List.displayName = 'List';
